import { QuestionActions } from '../Question';
import { NavigationActions } from '../Navigation';
import { ValidationActions } from './ValidationActions';
import { extractValidationErrorsFromPageResponse } from '../../state';

const validationReducer = (state, action) => {
  if (action.type === QuestionActions.VALIDATION_STATE_CHANGED) {
    const { errors, question, questionGroup, groupErrors, local, shouldDisplay = true, resetErrors = false } = action;
    if (local) {
      const validationErrors = resetErrors ? [] : (state?.pages?.validationErrors || []).filter(
        (e) =>
          (e.fieldType === 'question' && e.key !== question.appkey) ||
          (e.fieldType === 'questionGroup' && e.key !== questionGroup.key)
      );

      if (errors) {
        validationErrors.push({
          fieldType: 'question',
          questionType:
            action.question.attributes && action.question.attributes.format
              ? action.question.attributes.format
              : action.question.format
                ? action.question.format
                : null,
          key: action.question.appkey,
          shouldDisplay,
          errors,
        });
      }

      if (groupErrors) {
        validationErrors.push({
          fieldType: 'questionGroup',
          questionType:
            action.question.attributes && action.question.attributes.format
              ? action.question.attributes.format
              : action.question.format
                ? action.question.format
                : null,
          key: questionGroup.key,
          shouldDisplay,
          errors: groupErrors,
        });
      }

      return {
        ...state,
        pages: {
          ...state.pages,
          validationErrors
        }
      };
    }
  } else if (action.type === ValidationActions.VALIDATION_STATE_SHOW) {
    if (action.local && action.shouldDisplay) {
      const validationErrors = state?.pages?.validationErrors || [];

      const showValidationErrors = (entries) =>
        entries.map((e) => ({ ...e, shouldDisplay: true }));

      return {
        ...state,
        pages: {
          ...state.pages,
          validationErrors: showValidationErrors(validationErrors)
        }
      };
    }
  } else if (action.type === NavigationActions.PAGE_REQUEST_COMPLETED) {
    const validationErrors = extractValidationErrorsFromPageResponse(
      action.nextPage
    );

    return {
      ...state,
      pages: {
        ...state.pages,
        validationErrors
      }
    };
  } else if (action.type === QuestionActions.VALIDATION_FOR_POSTAL_CODE_COMPLETE ) {
    const validationErrors = extractValidationErrorsFromPageResponse(action.pageResponse);
    const postalCodeValidation = validationErrors.find(v => v.key === 'postalCode');
    if (postalCodeValidation) {
      const stateValidationErrors = (state?.pages?.validationErrors || []).filter(v => v.key !== 'postalCode');
      postalCodeValidation.shouldDisplay = true;
      return {
        ...state,
        pages: {
          ...state.pages,
          validationErrors: [...stateValidationErrors, postalCodeValidation]
        }
      };
    } else {
      return state;
    }
  } else if (action.type === ValidationActions.VALIDATION_RESET) {
    return {
      ...state,
      pages: {
        ...state.pages,
        validationErrors: []
      }
    };
  }

  return state;
};

export default validationReducer;
